import React from "react";

export default function Label({tekst, context}){

    return(
        <span className={`hq-label inline-block ${context}`}>{tekst}</span>
    )
}